/** Full page navigations, kept apart so tests can observe them (jsdom can't spy on `location`). */
export const browserNavigation = {
  /** Leave for another site, e.g. Stripe's 3DS page. */
  assign: (url: string) => window.location.assign(url),
  /** Load this URL again from the server without a history entry, so Rails decides what to show. */
  reloadFromServer: () => window.location.replace(window.location.href),
  reload: () => window.location.reload(),
};
